import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogBody, DialogActions } from './dialog';
import { Button } from './button';
import { Input } from './input';
import { Field, Label } from './fieldset';

const ProyectoDialog = ({ isOpen, onClose, onSubmit, proyecto, loading }) => {
  const [nombre, setNombre] = useState('');

  const isEdit = Boolean(proyecto);

  useEffect(() => {
    if (proyecto) {
      setNombre(proyecto.nombre || '');
    } else {
      setNombre('');
    }
  }, [proyecto, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombre.trim()) return;

    await onSubmit({
      nombre: nombre.trim(),
      ...(proyecto ? { id: proyecto.id } : {}),
    });

    setNombre('');
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{isEdit ? 'Editar Proyecto' : 'Nuevo Proyecto'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogBody>
          <Field>
            <Label>Nombre del proyecto</Label>
            <Input
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej. Construcción Tramo Norte"
              required
              autoFocus
            />
          </Field>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={onClose} type="button">
            Cancelar
          </Button>
          <Button type="submit" disabled={!nombre.trim() || loading}>
            {loading ? 'Guardando...' : isEdit ? 'Guardar' : 'Crear Proyecto'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ProyectoDialog;
